import React from "react";
import {NavLink} from "react-router-dom";
import {colors} from "../../../../../shared/theme/colors";
import {ListItem, ListItemIcon, Typography} from "@mui/material";

const DrawerListItem = (props) => {
    return (
        <ListItem
            sx={{
                padding: 0,
                "& > .active > .MuiListItemIcon-root": {
                    color: colors.primary.main,
                },
                "& > .active > h6": {
                    color: colors.font.dark,
                },
                "& > .active": {
                    backgroundColor: colors.grey.light,
                    borderLeft: `4px solid ${colors.primary.light}`,
                },
            }}
        >
            <NavLink
                to={props.to}
                className={({ isActive }) => (isActive ? "active" : "")}
                style={{
                    width: "100%",
                    display: "inline-flex",
                    padding: "16px 8px",
                    textDecoration: "none",
                }}
            >
                <ListItemIcon>{props.icon}</ListItemIcon>
                <Typography
                    variant={props.fontStyle}
                    sx={{
                        color: colors.font.light,
                        alignSelf: "center",
                    }}
                >
                    {props.text}
                </Typography>
            </NavLink>
        </ListItem>
    )
}


export default DrawerListItem;
